import { ButtonProps } from "@src/components/ui-components/Buttons/Button/Button";
import { useState } from "react";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { Text } from "../Text/Text";
import { TextInputField } from "../TextInputField/TextInputField";

type TextFieldModalPopupProps = {
  id: string;
  title: string;
  placeholder: string;
  onConfirm: (popUpId: string, name: string) => void;
  actionTitle?: string;
  actionButtonType?: ButtonProps["type"];
  defaultValue?: string;
  label?: string;
  dataCy?: string;
};

export const TextFieldModalPopup = ({
  id,
  title,
  placeholder,
  onConfirm,
  actionTitle,
  actionButtonType,
  defaultValue,
  label,
  dataCy,
}: TextFieldModalPopupProps) => {
  const [value, setValue] = useState(defaultValue ?? "");

  return (
    <ModalPopup
      id={id}
      title={title}
      onActionClicked={() => onConfirm(id, value)}
      actionTitle={actionTitle}
      actionButtonType={actionButtonType}
      children={
        <div>
          {label && <Text text={label} textAlign="left" marginBottom={16} />}
          <TextInputField
            value={value}
            onChange={(text) => setValue(text)}
            fullWidth
            onEnterPressed={() => onConfirm(id, value)}
            placeholder={placeholder}
            dataCy={dataCy}
          />
          <p id="error-message"></p>
        </div>
      }
    />
  );
};
